import { useState } from "react";
import getApiUrl from '../../utils/getApiUrl';

const API = getApiUrl();

const authFetch = (url, options = {}) => {
  const token = localStorage.getItem("auth_token");
  return fetch(url, {
    ...options,
    credentials: "include",
    headers: { ...(options.headers || {}), ...(token ? { Authorization: `Bearer ${token}` } : {}) },
  });
};


export default function PrescripteurModal({ prescripteur, typesPrescripteurs, onSave, onClose }) {
  const [nom, setNom] = useState(prescripteur?.nom_organisme || "");
  const [type, setType] = useState(prescripteur?.type_prescripteur || "CCAS");
  const [statut, setStatut] = useState(prescripteur?.statut || "prospect");
  const [score, setScore] = useState(prescripteur?.score_potentiel || 5);
  const [cp, setCp] = useState(prescripteur?.code_postal || "");
  const [ville, setVille] = useState(prescripteur?.ville || "");
  const [dept, setDept] = useState(prescripteur?.departement || "");
  const [adresse, setAdresse] = useState(prescripteur?.adresse || "");
  const [tel, setTel] = useState(prescripteur?.telephone_standard || "");
  const [email, setEmail] = useState(prescripteur?.email_general || "");
  const [web, setWeb] = useState(prescripteur?.site_web || "");
  const [notes, setNotes] = useState(prescripteur?.notes || "");
  const [contacts, setContacts] = useState(prescripteur?.contacts || []);
  const [saving, setSaving] = useState(false);
  const [tab, setTab] = useState("info");
  
  // Nouveau contact
  const [cNom, setCNom] = useState("");
  const [cFonc, setCFonc] = useState("");
  const [cTel, setCTel] = useState("");
  const [cMob, setCMob] = useState("");
  const [cEmail, setCEmail] = useState("");

  async function save() {
    if (!nom) { alert("Nom requis"); return; }
    setSaving(true);
    const data = { nom_organisme: nom, type_prescripteur: type, statut, score_potentiel: score, code_postal: cp, ville, departement: dept, adresse, telephone_standard: tel, email_general: email, site_web: web, notes, contacts };
    const url = prescripteur?.id ? `${API}/api/grands-comptes/prescripteurs/${prescripteur.id}` : `${API}/api/grands-comptes/prescripteurs`;
    try {
      const r = await authFetch(url, { method: prescripteur?.id ? "PUT" : "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(data) });
      if (r.ok) { onSave(); onClose(); }
    } catch (e) { alert(e); }
    setSaving(false);
  }

  function addC() {
    if (!cNom) return;
    setContacts([...contacts, { nom: cNom, fonction: cFonc, telephone_fixe: cTel, telephone_mobile: cMob, email: cEmail, est_principal: contacts.length === 0 }]);
    setCNom(""); setCFonc(""); setCTel(""); setCMob(""); setCEmail("");
  }

  function delC(i) { setContacts(contacts.filter((_, idx) => idx !== i)); }

  const Input = ({ v, set, ph, tw }) => <input type="text" value={v} onChange={e => set(e.target.value)} placeholder={ph} className={`bg-slate-700 border border-slate-600 rounded-lg px-3 py-2 text-white text-sm ${tw || "w-full"}`} />;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 p-4">
      <div className="bg-slate-800 border border-slate-600 rounded-2xl w-full max-w-2xl max-h-[90vh] flex flex-col">
        <div className="border-b border-slate-700 p-4 flex justify-between">
          <h2 className="text-xl font-bold text-white">{prescripteur ? "Modifier" : "Nouveau"}</h2>
          <button onClick={onClose} className="text-slate-400 hover:text-white text-2xl">&times;</button>
        </div>

        <div className="flex gap-2 px-4 py-2 border-b border-slate-700">
          <button onClick={() => setTab("info")} className={`px-4 py-2 rounded ${tab === "info" ? "bg-amber-600 text-white" : "bg-slate-700 text-slate-300"}`}>Infos</button>
          <button onClick={() => setTab("contacts")} className={`px-4 py-2 rounded ${tab === "contacts" ? "bg-amber-600 text-white" : "bg-slate-700 text-slate-300"}`}>Contacts ({contacts.length})</button>
        </div>

        <div className="flex-1 overflow-y-auto p-4 space-y-3">
          {tab === "info" ? (
            <>
              <Input v={nom} set={setNom} ph="Nom de l'organisme *" />
              <div className="grid grid-cols-2 gap-3">
                <select value={type} onChange={e => setType(e.target.value)} className="bg-slate-700 border border-slate-600 rounded-lg px-3 py-2 text-white text-sm">
                  {Object.entries(typesPrescripteurs || {}).map(([k, v]) => <option key={k} value={k}>{v.nom_complet}</option>)}
                </select>
                <select value={statut} onChange={e => setStatut(e.target.value)} className="bg-slate-700 border border-slate-600 rounded-lg px-3 py-2 text-white text-sm">
                  <option value="prospect">Prospect</option>
                  <option value="contacte">Contacté</option>
                  <option value="actif">Actif</option>
                  <option value="inactif">Inactif</option>
                </select>
              </div>
              <div><span className="text-sm text-slate-400">Score: {score}/10</span><input type="range" min="1" max="10" value={score} onChange={e => setScore(+e.target.value)} className="w-full" /></div>
              <div className="grid grid-cols-3 gap-3">
                <Input v={cp} set={setCp} ph="CP" />
                <Input v={ville} set={setVille} ph="Ville" />
                <Input v={dept} set={setDept} ph="Dép" />
              </div>
              <Input v={adresse} set={setAdresse} ph="Adresse" />
              <div className="grid grid-cols-2 gap-3">
                <Input v={tel} set={setTel} ph="Téléphone" />
                <Input v={email} set={setEmail} ph="Email" />
              </div>
              <Input v={web} set={setWeb} ph="Site web" />
              <textarea value={notes} onChange={e => setNotes(e.target.value)} placeholder="Notes" rows={2} className="w-full bg-slate-700 border border-slate-600 rounded-lg px-3 py-2 text-white text-sm" />
            </>
          ) : (
            <>
              {contacts.map((c, i) => (
                <div key={i} className="bg-slate-700/50 rounded p-2 flex justify-between">
                  <div>
                    <span className="text-white">{c.nom}</span> {c.est_principal && <span className="text-amber-400 text-xs">★</span>}
                    <div className="text-xs text-slate-400">{c.fonction} {c.telephone_fixe} {c.telephone_mobile} {c.email}</div>
                  </div>
                  <button onClick={() => delC(i)} className="text-red-400">✕</button>
                </div>
              ))}
              <div className="bg-slate-700/30 rounded p-3 space-y-2">
                <span className="text-white text-sm">Ajouter</span>
                <div className="grid grid-cols-2 gap-2">
                  <Input v={cNom} set={setCNom} ph="Nom *" />
                  <Input v={cFonc} set={setCFonc} ph="Fonction" />
                </div>
                <div className="grid grid-cols-2 gap-2">
                  <Input v={cTel} set={setCTel} ph="Tél fixe" />
                  <Input v={cMob} set={setCMob} ph="Mobile" />
                </div>
                <Input v={cEmail} set={setCEmail} ph="Email" />
                <button onClick={addC} className="px-3 py-1 bg-green-600 text-white rounded text-sm">+ Ajouter</button>
              </div>
            </>
          )}
        </div>

        <div className="border-t border-slate-700 p-4 flex justify-end gap-2">
          <button onClick={onClose} className="px-4 py-2 bg-slate-700 text-white rounded">Annuler</button>
          <button onClick={save} disabled={saving} className="px-4 py-2 bg-amber-600 text-white rounded">{saving ? "..." : "Enregistrer"}</button>
        </div>
      </div>
    </div>
  );
}
